document.addEventListener('click', function (e) {
  var minusBtn = e.target.closest('.cart__mini-qty--minus');
  var removeBtn = e.target.closest('.remove-from-cart');

  if (!minusBtn && !removeBtn) return;

  var row = (minusBtn || removeBtn).closest('.ajaxcart__product');
  if (!row) return;

  var input = row.querySelector('.cart__mini-qty--input');
  var currentQty = input ? parseInt(input.value, 10) : null;

  // Sirf intercept karo jab: remove icon directly click hua, YA minus click hua aur qty 1 hai
  var shouldRemove = removeBtn || (minusBtn && currentQty === 1);
  if (!shouldRemove) return;

  e.preventDefault();
  e.stopPropagation(); // nuranium.js ke purane delegated handlers ko chalne se roko

  // Use Shopify's exact line key so identical variants with different
  // Hanging/Panels properties remain independent.
  var lineKey = (removeBtn && removeBtn.dataset.productId) ||
                   (input && input.dataset.id);

  if (!lineKey) {
    console.error('Cart quick-remove: line key not found', row);
    return;
  }

  // turant visual feedback - user ko lagega instant hua
  row.style.transition = 'opacity 0.2s, max-height 0.3s';
  row.style.opacity = '0.3';
  row.style.pointerEvents = 'none';

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: 0 })
  })
    .then(function (res) {
      if (!res.ok) throw new Error('Could not remove cart item');
      return res.json();
    })
    .then(function (cart) {
      // row ko poori tarah hata do
      row.style.maxHeight = '0px';
      row.style.overflow = 'hidden';
      setTimeout(function () { row.remove(); }, 300);

      // count/subtotal khud update karo - theme ke buggy Currency.convertAll call par depend nahi karna
      var moneyFormat = (window.theme && window.theme.moneyFormat) || '₹{{amount}}';
      var formattedTotal = (window.Shopify && Shopify.formatMoney)
        ? Shopify.formatMoney(cart.total_price, moneyFormat)
        : '₹' + (cart.total_price / 100).toFixed(2);

      document.querySelectorAll('#CartCount, #CartCountCavas').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      var cartTotalEl = document.getElementById('cart_total');
      if (cartTotalEl) cartTotalEl.innerHTML = formattedTotal;
      document.querySelectorAll('#cart-info .subtotal span').forEach(function (el) {
        el.innerHTML = formattedTotal;
      });

      // Render the server's empty state after the last line is removed.
      if (cart.item_count === 0) {
        document.getElementById('desktop_cart')?.classList.remove('item_count');
        document.querySelectorAll('.form-cart__extent').forEach(function (el) {
          el.remove();
        });
        return fetch('/cart?view=json')
          .then(function (res) {
            if (!res.ok) throw new Error('Could not refresh cart');
            return res.text();
          })
          .then(function (html) {
            var cartInfo = document.getElementById('cart-info');
            if (cartInfo) cartInfo.innerHTML = html;
          });
      }
    })
    .catch(function (err) {
      console.error('Mini cart remove failed:', err);
      row.style.opacity = '1';
      row.style.pointerEvents = 'auto';
    });
}, true); // capture: true zaroori hai taake yeh nuranium.js ke handlers se pehle chale
